<p-toast position="top-right"></p-toast>
<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
<router-outlet></router-outlet>